"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkupImage = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var MediaContext_1 = require("../../MediaContext");
function MarkupImage(_a) {
    var _b, _c;
    var imageInfo = _a.imageInfo, imageSrc = _a.imageSrc, onLoad = _a.onLoad;
    var _js = (0, MediaContext_1.useMediaContext)()._js;
    var _d = React.useState(null), imageElement = _d[0], setImageElement = _d[1];
    var imageRef = React.useCallback(function (node) {
        setImageElement(node);
    }, []);
    return (React.createElement(React.Fragment, null, imageInfo && imageSrc && (React.createElement(react_1.Image
    // The source image needs to be styled at its natural size for the
    // "renderAtNaturalSize" feature of CROPRO and marker.js to work correctly.
    , { 
        // The source image needs to be styled at its natural size for the
        // "renderAtNaturalSize" feature of CROPRO and marker.js to work correctly.
        w: "".concat(imageInfo.width, "px"), h: "".concat(imageInfo.height, "px"), 
        // CROPRO and marker.js require that the image is loaded and visible on the page
        // before instantiating their editors. We need to load the full size edited image,
        // but we don't want the user to see it, so we position it way off the screen as a
        // workaround.
        position: "fixed", top: "-100000px", maxWidth: "initial", objectFit: "none", 
        // Setting the crossOrigin would only be necessary if the image src is from a
        // a different domain. Adding it here in case our image urls are different in xprem.
        crossOrigin: "anonymous", src: imageSrc, alt: (_c = (_b = imageInfo.exif) === null || _b === void 0 ? void 0 : _b.FileName) !== null && _c !== void 0 ? _c : _js('Source image'), ref: imageRef, onLoad: function () { return (imageElement ? onLoad(imageElement) : function () { }); } }))));
}
exports.MarkupImage = MarkupImage;
